import React, { useMemo } from "react";
import { Modal, Table, Button, Spinner } from "react-bootstrap";
import CustomPagination from "../../comman/CustomPagination";
import CloseBtn from "../CloseBtn";
import { DEFAULT_PAGE_OPTIONS } from "../../../utils/constants";
import SimpleTable from "../../comman/custom-table/SimpleTable";

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-";

const DeliveryListModal = ({
  show,
  onHide,
  order,
  loading,
  list,
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
}) => {
  const rows = useMemo(
    () =>
      (Array.isArray(list) ? list : []).map((row, idx) => {
        const serial = (page - 1) * pageSize + (idx + 1);
        const deliveredRaw = row?.delivered_date ?? null;

        return {
          id: row?.id ?? `${serial}`, // key field
          serial,
          client_name: row?.client_name || "—",
          number: row?.number || "—",
          address: row?.address || "—",
          tracking_url: row?.tracking_url || null,
          status: row?.status || "—",
          tracking_no: row?.tracking_no || "—",
          courier: row?.courier || "—",
          courier_mode: row?.courier_mode || "—",
          deliveredRaw, // for sorting
          deliveredStr: fmtDate(deliveredRaw), // for display
          delivery_tat: row?.delivery_tat ?? "—",
          delivery_remark: row?.delivery_remark || "—",
        };
      }),
    [list, page, pageSize, fmtDate]
  );
  const columns = useMemo(
    () => [
      {
        id: "serial",
        header: "#",
        sortable: false,
        minWidth: 60,
        cell: (_v, row) => row.serial,
      },
      {
        id: "client_name",
        header: "Client Name",
        accessor: "client_name",
        sortType: "text",
        minWidth: 160,
      },
      {
        id: "number",
        header: "Number",
        accessor: "number",
        sortType: "text",
        minWidth: 120,
      },
      {
        id: "address",
        header: "Address",
        accessor: "address",
        sortType: "text",
        minWidth: 220,
        className: "small",
        cell: (_v, row) => (
          <div className="d-flex flex-column lh-sm">
            <p className="m-0">{row.address}</p>
            {row.tracking_url ? (
              <a
                href={row.tracking_url}
                target="_blank"
                rel="noreferrer"
                className="mt-1"
                onClick={(e) => e.stopPropagation()}
              >
                Track →
              </a>
            ) : null}
          </div>
        ),
      },
      {
        id: "status",
        header: "Status",
        accessor: "status",
        sortType: "text",
        minWidth: 120,
      },
      {
        id: "tracking_no",
        header: "Tracking No",
        accessor: "tracking_no",
        sortType: "text",
        minWidth: 160,
      },
      {
        id: "courier",
        header: "Courier",
        accessor: "courier",
        sortType: "text",
        minWidth: 140,
      },
      {
        id: "courier_mode",
        header: "Courier Mode",
        accessor: "courier_mode",
        sortType: "text",
        minWidth: 140,
      },
      {
        id: "delivered_date",
        header: "Delivered Date",
        accessor: "deliveredRaw", // sort on raw date
        sortType: "date",
        minWidth: 160,
        cell: (_v, row) => row.deliveredStr,
      },
      {
        id: "delivery_tat",
        header: "Delivery TAT",
        accessor: "delivery_tat",
        sortType: "auto", // numeric or text
        minWidth: 120,
      },
      {
        id: "delivery_remark",
        header: "Delivery Remark",
        accessor: "delivery_remark",
        sortType: "text",
        className: "small",
        minWidth: 220,
      },
    ],
    []
  );
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={list?.length > 0 ? "xl" : "md"}
      centered
    >
      <CloseBtn onClick={onHide} color="#bf352b" />
      <Modal.Header>
        <Modal.Title>
          Deliveries — Order {order?.order_no ?? order?.id}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <div className="position-relative table-cover">
          {loading && (
            <div
              className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{ background: "rgba(255,255,255,0.6)", zIndex: 2 }}
            >
              <Spinner animation="border" />
            </div>
          )}
          <Table responsive bordered hover size="sm" className="mb-2">
            <thead>
              <tr>
                <th>#</th>
                <th>Client Name</th>
                <th>Number</th>
                <th style={{ minWidth: 220 }}>Address</th>
                <th>Status</th>
                <th>Tracking No</th>
                <th>Courier</th>
                <th>Courier Mode</th>
                <th>Delivered Date</th>
                <th>Delivery TAT</th>
                <th>Delivery Remark</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(list) && list.length ? (
                list.map((row, idx) => (
                  <tr key={row.id ?? idx}>
                    <td>{(page - 1) * pageSize + (idx + 1)}</td>
                    <td>{row.client_name || "-"}</td>
                    <td>{row.number || "-"}</td>
                    <td className="small">
                      <div className="d-flex flex-column lh-sm">
 <p className="m-0">{row.address || "-"}</p>
                      {row.tracking_url ? (
                        <>
                        
                          <a
                            href={row.tracking_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Track →
                          </a>
                        </>
                      ) : null}
                      </div>
                    
                    </td>
                    <td>{row.status || "-"}</td>
                    <td>{row.tracking_no || "-"}</td>
                    <td>{row.courier || "-"}</td>
                    <td>{row.courier_mode || "-"}</td>
                    <td>{fmtDate(row.delivered_date)}</td>
                    <td>{row.delivery_tat ?? "-"}</td>
                    <td className="small">{row.delivery_remark || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={11} className="text-center text-muted">
                    No delivery records found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div> */}
        {list?.length > 0 ? (
          <>
            <SimpleTable
              data={rows}
              columns={columns}
              loading={loading}
              keyField="id"
              responsive
              size="sm"
              emptyMessage={"no records found"}
              headerSticky
              tableProps={{ bordered: true, hover: true, className: "mb-2" }}
            />
            <CustomPagination
              currentPage={page}
              totalPages={totalPages}
              total={total}
              pageSize={pageSize}
              setPageSize={() => {}}
              setCurrentPage={onPageChange}
              onPageChange={onPageChange}
              perPageOptions={DEFAULT_PAGE_OPTIONS}
            />
          </>
        ) : (
          <h5 className="text-center">no records found</h5>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeliveryListModal;
